import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultLocale, isRtlLocale, localeResources, locales } from '@soroush/shared/locales';

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: localeResources.en },
      fa: { translation: localeResources.fa },
    },
    lng: defaultLocale,
    fallbackLng: 'en',
    supportedLngs: [...locales],
    interpolation: { escapeValue: false },
  })
  .then(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = isRtlLocale(i18n.language) ? 'rtl' : 'ltr';
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = isRtlLocale(lng) ? 'rtl' : 'ltr';
});

export default i18n;
